import { Input } from "@/components/Form/Input"
import { Title } from "@/components/Title"
import { Control, FieldValues, Path, useFormContext } from "react-hook-form"
import { FormattedMessage, useIntl } from "react-intl"

export const Expense3DSPassword = <T extends FieldValues>({
  isVertex,
  control,
  withoutPhone = false,
}: {
  control: Control<T>
  withoutPhone?: boolean
  isVertex?: boolean
}) => {
  const { $t: t } = useIntl()
  const { watch } = useFormContext()
  if (isVertex) return null
  return (
    <div>
      {!withoutPhone && (
        <Title variant="title" className="mb-2 mt-2.5">
          <FormattedMessage id="pa_186" />
        </Title>
      )}
      <div>
        {!withoutPhone && <Input.Phone withFlag control={control} name={"mobile" as Path<T>} placeholder={t({ id: "pa_186" })} required />}
        <Title variant="title" className="mt-3">
          <FormattedMessage id="pin" />
        </Title>
        <Input.Form
          control={control}
          type="password"
          name={"password3ds" as Path<T>}
          placeholder={t({ id: "create-pin" })}
          required={!isVertex}
          className="my-2.5"
          isPinField
        />
        <Input.Form
          control={control}
          type="password"
          name={"password3ds_confirm" as Path<T>}
          placeholder={t({ id: "confirm-pin" })}
          required={!isVertex}
          rules={{
            validate: (value: string) => value === watch("password3ds") || t({ id: "pin-not-match" }),
          }}
          isPinField
          className="mb-2"
        />
      </div>
    </div>
  )
}
